import { render } from "./MenuUser.vue?vue&type=template&id=bdc7cb12&scoped=true"
import script from "./MenuUser.vue?vue&type=script&lang=js"
export * from "./MenuUser.vue?vue&type=script&lang=js"

import "./MenuUser.vue?vue&type=style&index=0&id=bdc7cb12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc7cb12"]])

export default __exports__